<template>
  <v-dialog v-model="inviteDialog" width="500">
    <template v-slot:activator="{ on }">
      <v-btn v-if="admin" color="primary" v-on="on">
        <v-icon left>mdi-mail</v-icon>
        {{ $t("users.InviteTraveler.title") }}
      </v-btn>
      <v-list-item v-else v-on="on">
        <v-list-item-title>{{ $t("users.InviteTraveler.title") }}</v-list-item-title>
      </v-list-item>
    </template>
    <v-card v-if="!finished">
      <v-card-title class="headline primary white--text" primary-title>{{
        $t(`users.InviteTraveler.${admin ? "inviteAdmin" : "cardTitle"}`)
      }}</v-card-title>
      <div class="overflow-y-auto" style="max-height: 70vh">
        <v-card-text class="mt-2">
          {{ $t("company.tabs.administrators.button.description") }}
          <v-row class="my-1" dense v-for="(email, index) in inviteEmails" :key="index">
            <v-col cols="10">
              <v-text-field
                dense
                :ref="`textfield-${index}`"
                @keyup.enter.native="tryAdd(index)"
                :hide-details="index != 0"
                @paste="onPaste(index)"
                v-model="inviteEmails[index]"
                persistent-hint
                hint="You can also paste multiple emails separated by comma"
                :placeholder="$t('common.email')"
              ></v-text-field>
            </v-col>
            <v-col cols="2">
              <v-btn
                v-if="index == inviteEmails.length - 1"
                icon
                color="primary"
                @click="addEmail"
                class="ml-3"
              >
                <v-icon>mdi-plus-circle-outline</v-icon>
              </v-btn>
              <v-btn
                v-else
                icon
                color="primary"
                class="ml-3"
                @click="inviteEmails.splice(index, 1)"
              >
                <v-icon>mdi-minus-circle-outline</v-icon>
              </v-btn>
            </v-col>
          </v-row>
          <div class="d-flex flex-row justify-space-between">
            <v-select
              class="mr-2"
              style="max-width: 200px"
              v-model="openInApp"
              :items="linkOptions"
              item-text="name"
              item-value="val"
              hint="Open Preferences"
              persistent-hint
            ></v-select>
            <v-select
              class="ml-2"
              style="max-width: 200px"
              v-model="subgroup"
              :items="allSubgroups"
              item-text="name"
              item-value="id"
              label="No sobgroup"
              hint="Invite to subgroup"
              persistent-hint
              single-line
            ></v-select>
          </div>
          <p class="red--text" v-if="feedback">{{ feedback }}</p>
        </v-card-text>
      </div>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="closeDialog()">{{ $t("common.cancel") }}</v-btn>
        <v-btn color="primary" :loading="isInviting" @click="inviteUser()">{{
          $t("common.send")
        }}</v-btn>
      </v-card-actions>
    </v-card>
    <v-card v-else>
      <v-card-title class="headline primary white--text" primary-title>{{
        $t("common.success")
      }}</v-card-title>
      <v-card-text class="mt-2">{{
        $t("company.tabs.administrators.button.success_message", {
          user: inviteEmails.join(","),
        })
      }}</v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="closeDialog()">{{ $t("common.close") }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import functions from "@/firebase/functions";

export default {
  name: "InviteTraveler",
  props: ["admin"],
  data() {
    return {
      inviteDialog: false,
      isInviting: false,
      inviteEmails: [""],
      feedback: null,
      finished: false,

      subgroup: null,
      openInApp: true,
      linkOptions: [
        {
          val: true,
          name: "Open Mobile App",
        },
        {
          val: false,
          name: "Open Web App",
        },
      ],
    };
  },
  computed: {
    allSubgroups() {
      const subgroupsIds = Object.keys(this.$store.state.trip.subgroups);
      const subgroupsAll = this.$store.state.trip.subgroups;

      const mapped = subgroupsIds.map((id) => subgroupsAll[id]);
      mapped.unshift({ id: null, name: "None" });
      return mapped;
    },
  },
  methods: {
    closeDialog() {
      this.inviteDialog = false;
      this.finished = false;
      this.inviteEmails = [""];
      this.isInviting = false;
    },
    onPaste(index) {
      console.log(`index is : ${index}`);

      setTimeout(() => {
        console.log(`index is : ${index}`);
        const emails = this.inviteEmails[index];
        console.log(emails);

        if (emails.includes(",")) {
          const emailArr = emails.replace(/ /gi, "").split(",");
          this.inviteEmails[index] = emailArr.shift();

          emailArr.forEach((email) => {
            if (email !== "") {
              this.inviteEmails.push(email);
            }
          });
        }
      }, 50);
    },
    tryAdd(index) {
      if (index === this.inviteEmails.length - 1) {
        this.addEmail();
      }
    },
    addEmail() {
      this.inviteEmails.push("");
      const ref = `textfield-${this.inviteEmails.length - 1}`;
      setTimeout(() => {
        this.$refs[ref][0].focus();
      }, 50);
    },
    inviteUser() {
      console.log("inviting users:", this.inviteEmails);

      // let isEmailValid = /[A-Z0-9a-z._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,64}/.test(
      //   this.inviteEmail
      // );

      // if (!isEmailValid) {
      //   this.feedback = "Please provide a valid email";
      //   return;
      // }

      this.feedback = null;
      const { trip } = this.$store.state.trip;
      const company = this.$store.getters.tripCompany;
      const companyName = company != null ? company.name : "Trip Loop";
      const language = company != null ? company.language : null;

      this.isInviting = true;

      console.log("sending data for invite");
      const data = {
        tripId: trip.id,
        emails: this.inviteEmails.map((m) => m.toLowerCase()),
        groupName: trip.name,
        subgroupId: this.subgroup,
        openInApp: this.openInApp,
        admin: this.$props.admin || false,
        companyName,
        companyId: trip.company,
        language,
      };
      console.log(data);

      functions
        .sendJoinGroupInvite(data)
        .then((result) => {
          console.log(result);
          this.isInviting = false;
          this.finished = true;
        })
        .catch((error) => {
          const { message } = error;
          this.isInviting = false;
          this.feedback = message;
        });
    },
  },
};
</script>
